module.exports = __webpack_public_path__ + "static/media/all-onceagain.b7303a02.mp3";